import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { ErrorLayout, Loader } from '@axiom/ui';

import { AvailabilityPreferencesView } from '../AvailabilityPreferencesView/AvailabilityPreferencesView';
import { WindowUtil } from '../../utils/window-util';
import { ConfirmationsApi } from '../../api/confirmations-api';

export const AvailabilityPreferencesConfirmation = () => {
  const [confirmationError, setConfirmationError] = useState<
    false | null | Error
  >(null);

  const { token } = useParams();

  // Use URL query as this route is not in auth and doesn't have access to user object
  const { candidateId } = WindowUtil.getUrlQuery();

  const invalidIds = !token || !candidateId || typeof candidateId !== 'string';

  useEffect(() => {
    if (invalidIds) {
      return;
    }
    ConfirmationsApi.updateConfirmation(token, {
      candidateId,
      availabilityPreferencesUpdated: true,
    })
      .then(() => {
        setConfirmationError(false);
      })
      .catch(err => {
        setConfirmationError(err);
      });
  }, []);

  if (invalidIds || confirmationError) {
    return (
      <ErrorLayout
        name="AVAILABILITY-PREFERENCES-CONFIRMATION-ERROR-PAGE"
        errorMessage="We can't confirm your availability preferences at this time"
      />
    );
  }

  if (confirmationError === null) {
    return <Loader name="AVAILABILITY-PREFERENCES-CONFIRMATION-LOADER" />;
  }

  return (
    <div data-test="AVAILABILITY-PREFERENCES-CONFIRMATION-PAGE">
      <AvailabilityPreferencesView />
    </div>
  );
};
